import { call, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";

import { forgotPasswordApi } from "./forgotPassword.api";
import { forgotPasswordActions } from "./forgotPassword.actions";

function* handleForgotPassword(
  dto: ReturnType<typeof forgotPasswordActions.request>
) {
  try {
    yield call(forgotPasswordApi, dto.payload);
  } catch (error) {
  }
}

export function* watchForgotPasswordRequest() {
  try {
    yield takeLatest(
      getType(forgotPasswordActions.request),
      handleForgotPassword
    );
  } catch (err) {}
}
